import * as React from 'react';
import type { Customer } from '@/types';
import { Pencil } from 'lucide-react';
import { Button } from '@/components/atoms/button';
import {AddressList } from '@/components/molecules/AddressList';
import { EditMyDetails } from '@/components/molecules/EditMyDetails';

type MyDetailsProps = {
  customer: Customer
}

export function MyDetails(props: MyDetailsProps) {
  const [updateMyDetailsIsOpen, setUpdateMyDetailsIsOpen] = React.useState(false);

  if(props.customer) {
    return(
      <div className="space-y-2">
        <div><span className="my-details">Name:</span><br />{props.customer.name}</div>
        <div><span className="my-details">Phone:</span><br />{props.customer.phone}</div>
        <div><span className="my-details">Mobile:</span><br />{props.customer.mobile}</div>
        <div><span className="my-details">Email:</span><br />{props.customer.email}</div>
        <Button onClick={() => setUpdateMyDetailsIsOpen(true)}><Pencil /> Edit</Button>
        <EditMyDetails isOpen={updateMyDetailsIsOpen} onOpenChange={setUpdateMyDetailsIsOpen} customer={props.customer} />
        <AddressList />
      </div>
    );
  }
}
